import { TFunction } from 'i18next'
import isNumber from 'lodash/isNumber'

import { TransactionOriginatorType } from '@features/transactions/enums/transactionOriginatorType'
import { TransactionSide } from '@features/transactions/types/transactionSide'

import { transactionOriginatorTypeToTranslationKey } from '../constants/transactionOriginatorTypeToTypeKey'

export interface TransactionTypeFromOrginatorReference {
  originatorId: string
  originatorType: TransactionOriginatorType
  translationKey: string
}

export const getTransactionTypeFromOriginatorReference = (
  amount: number | null,
  originatorReference: string | null,
  side: TransactionSide,
  t: TFunction,
): TransactionTypeFromOrginatorReference | undefined => {
  const originatorReferenceSplit = originatorReference?.split(':') ?? []
  const id = originatorReferenceSplit[1]
  const tKey = originatorReferenceSplit[0] as TransactionOriginatorType

  if (!tKey || !(tKey in transactionOriginatorTypeToTranslationKey)) {
    return undefined
  }

  if (tKey === TransactionOriginatorType.BankPayment && !!side && isNumber(amount)) {
    if (side === 'credit') {
      return {
        originatorId: id,
        originatorType: TransactionOriginatorType.BankPayment,
        translationKey: t('transactions.table.type.bank_payment.ingoing'),
      }
    } else {
      return {
        originatorId: id,
        originatorType: TransactionOriginatorType.BankPayment,
        translationKey: t('transactions.table.type.bank_payment.outgoing'),
      }
    }
  }

  return {
    originatorId: id,
    originatorType: tKey,
    translationKey: t(transactionOriginatorTypeToTranslationKey[tKey]),
  }
}
